import React from "react";
import { Circle } from "lucide-react";

export type BackendState = "idle" | "starting" | "ready" | "error";

interface StatusBarProps {
  fileName?: string;
  currentPage?: number;
  totalPages?: number;
  sizeBytes?: number;
  backend: BackendState;
}

const formatSize = (bytes?: number): string => {
  if (!bytes) return "";
  const mb = bytes / (1024 * 1024);
  return mb >= 1 ? `${mb.toFixed(1)} MB` : `${Math.round(bytes / 1024)} KB`;
};

const BACKEND_LABEL: Record<BackendState, string> = {
  idle: "Engine idle",
  starting: "Engine starting…",
  ready: "Engine ready",
  error: "Engine error",
};

const StatusBar: React.FC<StatusBarProps> = ({
  fileName,
  currentPage,
  totalPages,
  sizeBytes,
  backend,
}) => {
  return (
    <div className="status-bar">
      <span className="status-file">{fileName ?? "No document"}</span>
      {totalPages ? (
        <span className="status-pages">
          Page {currentPage ?? 1} / {totalPages}
        </span>
      ) : null}
      {sizeBytes ? <span className="status-size">{formatSize(sizeBytes)}</span> : null}
      <span className={`status-backend status-backend-${backend}`}>
        <Circle size={8} fill="currentColor" />
        {BACKEND_LABEL[backend]}
      </span>
    </div>
  );
};

export default StatusBar;
